import { createTheme } from "@mui/material";
import MuiCard from "./components/muiCard";
import { MuiAccordion, MuiAccordionSummary } from "./components/muiAccordion";
import MuiTextField from "./components/muiTextField";
import MuiInputBase from "./components/muiInputBase";
import MuiOutlinedInput from "./components/muiOutlinedInput";
import MuiDialog from "./components/muiDialog";
import createTypography from "./typography";
import MuiLink from "./components/muiLink";
import palette from "./palette";

const paletteTheme = createTheme({
  palette,
});

// Create the base typography object so we can reuse it and also provide a
// variantMapping that maps custom variants to proper DOM elements. This
// ensures variants like `p1` render as <p> (block) instead of a span.
const baseTypography = createTypography(paletteTheme);

// Map variants to semantic elements (block where appropriate).
const variantMapping = {
  // headers -> semantic headings
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  pageTitle: "h1",
  pageTitleNoMargin: "h1",
  pageTitleWhite: "h1",
  pageTitleDark: "h1",

  // paragraphs/body -> p (block)
  p1: "p",
  body1: "p",
  body1NoMargin: "p",
  body1White: "p",
  body1WhiteNoMargin: "p",
  body1Dark: "p",
  body1DarkNoMargin: "p",
  // inline link variant -> anchor (inline)
  p1Link: "a",

  // labels and captions can be spans
  label: "span",
  labelNoMargin: "span",
  labelWhite: "span",
  labelWhiteNoMargin: "span",
  labelDark: "span",
  labelDarkNoMargin: "span",

  // splash and other large text -> header semantics
  splashTitle: "h1",
  splashSubtitle: "h2",
  splashDescription: "p",

  // menu item -> div (block) so it gets spacing
  menuItem: "div",
  menuItemNoMargin: "div",

  // button and other small UI variants -> span
  button: "span",
  formLabel: "div",
};

const theme = createTheme(paletteTheme, {
  components: {
    MuiCard,
    MuiAccordion,
    MuiAccordionSummary,
    MuiTextField,
    MuiInputBase,
    MuiLink,
    MuiOutlinedInput,
    MuiDialog,
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          display: "none",
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping,
      },
    },
  },
  typography: {
    ...baseTypography,
    variantMapping,
  },
});

export default theme;
export { paletteTheme };
